module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/paulwasnotachristian_toc#fm_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Note to the Reader")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("All translations of Paul’s letters are mine based on the Nestle-Aland twenty-seventh edition Greek New Testament, unless otherwise indicated. Translations from other parts of the Bible are from the New Revised Standard Version (NRSV), unless otherwise indicated.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I have tried to avoid the use of technical terms, but there are times when they were useful. In light of this I have provided a brief glossary at the end of the book.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73032a16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paulwasnotachristian_fm01.vue
// module id = 72
// module chunks = 0